module.exports = __webpack_public_path__ + "static/media/immunology.c5722257.JPG";